import React from 'react';
import parseHTML, { fnParseHTMLWithPageData } from '../../utilities/parseHTML';
import sanitize from '../../utilities/parseHTML/purify';

const globalTransformer = ({ queried, location, pageContext: { categories, type } = { categories: [], type: '' } }) =>
{
    const { parseHTMLWithPageData } = fnParseHTMLWithPageData({ location }, ['learningCenter'])
    const { menuItems: mainMenuItems } = queried?.mainMenu ?? {};
    const { menuItems: globalNavItems } = queried?.globalNav ?? {};
    const { menuItems: globalAccountItems } = queried?.globalAccount ?? {};
    const {complianceBanner} = queried?.compliance ?? {};
    let allCategories = [];

    if (type === 'categories' || type === undefined)
    {
        allCategories = categories.map(item => ({ 
            isChecked: item.category.uri.replace(/\/$/, '') === location.pathname.replace(/\/$/, ''), testid: `filter-chip-${item.category.id}`,
            link: item.category.uri.replace(/\/$/, ''), 
            label: item?.category?.name || item?.category?.slug,
            component: <h2>{item.category.name || item.category.slug}</h2>, 
            id: item.category.id,
            isFilter: true,
        })) || [];
    }
    else
    {
        allCategories = queried?.subCategories?.edges.map(subCategory => ({
            isChecked: subCategory?.category?.uri.replace(/\/$/, '') === location.pathname.replace(/\/$/, ''), testid: `filter-chip-${subCategory?.category?.databaseId}`,
            link: subCategory?.category?.uri.replace(/\/$/, ''), 
            label: subCategory?.category?.name,
            component: subCategory?.category?.name,
            id: subCategory?.category?.databaseId,
            isFilter: true,  
        }));
    } 

    allCategories?.sort((a, b) => a?.label?.localeCompare(b.label));
    if (type === 'categories' || type === undefined)
    {
        allCategories?.unshift({
            isFilter: true,
            id: 'all',
            label: 'All',
            isChecked: !allCategories.some(item => item.isChecked),
            testid: 'filter-chip-all',
            link: '/learn',
            component: <h2>All</h2>,
        });
    }
    else
    {
        allCategories?.unshift({
            id: queried?.categoryData?.wpParent?.node?.id,
            label: queried?.categoryData?.wpParent?.node?.name,
            testid: 'filter-chip-go-back',
            link: queried?.categoryData?.wpParent?.node?.uri.replace(/\/$/, ''),
            isFilter: false,
        });
    }
    
    const subMenuParser = data => data?.map(n => (
        {
            databaseId: parseInt( `${n.databaseId}`, 10),
            label: parseHTML( n.label, ['learningCenter'] ).parsed,
            path: sanitize(n.path),
            submenu: {
                nodes: n?.submenu ? subMenuParser(n?.submenu?.nodes) : [],
            },
        })
    );

    const headerProps = {
        menuItems: subMenuParser(
            mainMenuItems?.nodes.filter((f) => f.parentDatabaseId === 0)
        ),
        globalNav: globalNavItems?.nodes?.filter( (f) => f.parentDatabaseId === 0) || null,
        globalAccount: globalAccountItems?.nodes?.filter( (f) => f.parentDatabaseId === 0) || null,
        applyText: queried?.ctaLabel?.rawMarkdownBody.trim(),
        applyUrl: queried?.ctaUrl?.rawMarkdownBody.trim(),
        banner: {
            ...complianceBanner,
            message: parseHTMLWithPageData( complianceBanner?.message || '' )?.parsed
        },
        categories: allCategories
    }

    const { menuItems: footerMenuItems } = queried?.footerMenu ?? {};
    const { menuItems: legaleseMenuItems } = queried?.legaleseMenu ?? {};

    const footerProps = {
        menuItems: subMenuParser(
            footerMenuItems?.nodes.filter((f) => f.parentDatabaseId === 0)
        ),
        legaleseMenu: legaleseMenuItems?.nodes,
        disclosure: parseHTMLWithPageData(queried?.disclosureMarkup?.html)
            ?.parsed,
        copyRight: parseHTMLWithPageData(
            queried?.copyrightMarkup?.rawMarkdownBody
        )?.parsed,
    };

    return {
        headerProps,
        footerProps,
    };
};

export default globalTransformer;
